import { redirect } from "react-router-dom"

export function IsUserAuth() {

    const token = localStorage.getItem('token') 
    if (!token) {
        return redirect('/')
    } 

    const settings = localStorage.getItem('settings') 
    if (!settings) {
        return redirect('/')
    } 

    return null
}